import { ImageAndTextDirection as T, ImageAndTextCtaBtnPosition as n } from "@nextgen-web-framework/all";
import { ComponentType as y } from "../../registries/types/propTypes.js";
import { CTABtnType as x } from "../../../components/ImageAndTextContainer/types/enum.js";
import f from "../text-only-transformer/text-only-transformer.js";
const I = (t) => {
  const e = Array.isArray(t == null ? void 0 : t.image_and_text) ? t == null ? void 0 : t.image_and_text[0] : t == null ? void 0 : t.image_and_text, { componentType: s, ...m } = f({
    text_only: {
      display_title: e.display_title,
      description: e.description,
      color_options: e.color_options,
      rounded: e.rounded
    }
  });
  let i = {
    componentType: y.image_and_text,
    direction: e.layout_options ?? T.LEFT_TEXT_RIGHT_IMAGE,
    imgList: [{ alt_text: "", image: {}, viewport: [], _metadata: {} }],
    link: {},
    textOnlyConfig: m
  };
  if (e != null && e.image) {
    const {
      cta: l,
      image: { images: _ }
    } = e, { type: o, button_title: d, url: r, target: c, ...g } = l;
    let a;
    switch (o) {
      case n.CENTER:
        a = n.CENTER;
        break;
      case n.RIGHT:
        a = n.RIGHT;
        break;
      default:
        a = n.LEFT;
        break;
    }
    i = {
      ...i,
      imgList: _,
      link: {
        url: r,
        target: c
      }
    }, i.button = o === x.NONE ? {} : {
      ...g,
      alignment: a,
      title: d
    };
  }
  return i;
};
export {
  I as default
};
//# sourceMappingURL=ImageAndText-transformer.js.map
